module.exports = __webpack_public_path__ + "img/gebaeudeansicht.941bdb6f.svg";